module.exports = __webpack_public_path__ + "media/images/about/bg05-ef228e433f0161369fe33e0dce04cade.png";